/* eslint-disable no-unused-vars */
import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import { Table } from 'src/components';
import { ReactComponent as EmbarqueIcon } from 'src/assets/icons/embarque.svg';
import { ReactComponent as Page } from 'src/assets/icons/oldPortal/pagina.svg';
import DefIcon from 'src/assets/base/page.svg';
import { isValid } from 'src/services/auth';

function List({ data, tabsContent, setTabsContent, setCurrentTab }) {
  return (
    <div className="listScroll">
      <div className="listPage">
        {Object.entries(data).map(([subkey, subitem]) => {
          if (typeof subitem === 'object') {
            return (
              <div key={`${subkey}`} className="listItem">
                <button
                  className="mainShadow"
                  onClick={() => {
                    setTabsContent((prevTabs) => {
                      const existingTabIndex = prevTabs.findIndex(
                        (tab) => tab?.title === subkey
                      );

                      if (existingTabIndex === -1) {
                        const newTabs = [
                          ...prevTabs,
                          {
                            title: subkey,
                            content: (
                              <Table
                                key={prevTabs.length}
                                selectedTable={data}
                                selectedItem={subitem}
                                tabIndex={prevTabs.length}
                              />
                            ),
                          },
                        ];

                        setCurrentTab(newTabs.length - 1);
                        return newTabs;
                      } else {
                        setCurrentTab(existingTabIndex);
                        return prevTabs;
                      }
                    });
                  }}
                >
                  {isValid(subitem.icone) ? (
                    <img
                      className="icon"
                      src={subitem.icone}
                      onError={(e) => {
                        e.currentTarget.src = DefIcon;
                      }}
                    />
                  ) : (
                    <EmbarqueIcon />
                  )}

                  <span>{subkey}</span>
                </button>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
}

export default List;

List.propTypes = {
  data: PropTypes.object,
  tabsContent: PropTypes.array,
  setTabsContent: PropTypes.func,
  setCurrentTab: PropTypes.func,
};
